import { Component, OnInit, Inject, OnChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UtilsService } from 'src/app/Services/utils.service';
import { UserData } from 'src/app/Services/data.model';
import { OtherApiService } from 'src/app/Services/other.service';
import { FeeApiService } from 'src/app/Services/fee.service';

@Component({
  selector: 'app-editTransaction',
  templateUrl: './editTransaction.component.html',
  styleUrls: ['./editTransaction.component.scss']
})
export class EditTransactionComponent implements OnInit, OnDestroy {
  entityId = localStorage.getItem('entityId');
   
  entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
  session = localStorage.getItem('session');
  receipt: any;
  reason: any;
  reasonFlag: boolean;
  cancellationRemark: any;
  validationForm: FormGroup;
  formData: FormData;
  receiptFormData: UserData = new UserData();
  chequeBounceCharge: number;
  cancellationCheckBounceDate: any;
  hasFormErrors: boolean;
  viewLoading = false;
  constructor(public dialogRef: MatDialogRef<EditTransactionComponent>,private fb : FormBuilder,
    private service: OtherApiService, private util: UtilsService,private feeService:FeeApiService,
    @Inject(MAT_DIALOG_DATA) public data: any, private ref: ChangeDetectorRef) {
      console.log(dialogRef)
     }

  ngOnInit() {
    console.log(this.data)
    this.viewLoading = true;
    this.receiptFormData = new UserData(); 
    this.validateStudentForm();
    this.receipt = this.data.receipt;
    this.reason ='chequeBounce'
    this.cancellationRemark = 'Cheque Bounce'
    this.cancellationCheckBounceDate = new Date();
    this.chequeBounceCharge = 0;
    this.reasonFlag = false;
    this.viewLoading = false;
  }

  validateStudentForm() {
    this.validationForm = this.fb.group({
      controlRemark: ['', Validators.compose([
        Validators.required,
      ]),
      ],
      controlDate: [new Date()],
      // controlCharges: ['', Validators.compose([
      //   Validators.required,
      //   // Validators.minLength(2),
      //   // Validators.maxLength(100),
      //   // Validators.pattern("[a-zA-Z0-9 \'\-\.]+$")
      // ]),
      // ],
    })
  }

  radioChange(){
    if(this.reason == 'chequeBounce'){
      this.reasonFlag = false;
      this.chequeBounceCharge = 0;
      this.cancellationRemark = 'Cheque Bounce'
      this.ref.detectChanges();
    }
    else{
      this.reasonFlag = true;
      this.cancellationRemark = ''
      this.chequeBounceCharge = null;
      this.ref.detectChanges();
    }
  }

  foo(data){
  this.dialogRef.close({ data, isEdit: false })
  }
  onSubmit(data) {
      this.hasFormErrors = false;
      const controls = this.validationForm.controls;
      /** check form */
      if (this.validationForm.invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        this.hasFormErrors = true;
        return;
      }
      if(!this.reasonFlag){
        if(!this.chequeBounceCharge == null)
        this.chequeBounceCharge = 0;
        
        if(!this.cancellationCheckBounceDate){
          this.util.alertNotificationMessage("Cheque Bounce Date is required.");
          return;
        }
      }
      let receiptData: any = {
            _id : this.receipt._id,
            entity : this.entityId,
            session: this.session,
            cancellationRemark: this.cancellationRemark,
            chequeBounceCharge: this.chequeBounceCharge,
          }
          
      if (!this.reasonFlag) {
        receiptData.cancellationCheckBounceDate = new Date(this.cancellationCheckBounceDate);
      }

      this.feeService.cancelReceipt(receiptData)
        .subscribe(res =>{
            this.util.alertMessage(this.receipt.receiptId + ' Receipt', 'Cancelled');
            this.dialogRef.close({ data, isEdit: true })
          },
          err=>{
            this.util.errmsg(err);
          })
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.validationForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
  
  onAlertClose($event) {
    this.hasFormErrors = false;
    // this.hasError = false;
  }
  ngOnDestroy() {
    // window.clearInterval();
  }
}
